/** Ids in the backend's `Currencies` / `currency` tables. */
export const CURRENCY_EUR = 1;
export const CURRENCY_LEK = 2;
export const CURRENCY_DEN = 3;

/** Deployment country ids. 1 Kosovo, 2 Albania, 3 North Macedonia. */
export const COUNTRY_KS = 1;
export const COUNTRY_AL = 2;
export const COUNTRY_MK = 3;

export type CurrencyInfo = {
	id: number;
	description: string;
	/** Display symbol. May be null if the backend row is unpopulated — fall back to `description`. */
	symbol: string | null;
	/**
	 * Quoted **against the deployment's own currency**, which is the pivot and always `1.0`.
	 *
	 * On PostmanAL: LEK `1.00000`, EUR `0.01041`, DEN `0.64300` — i.e. "what 1 LEK is worth in
	 * this currency". So LEK → EUR multiplies by the rate, and EUR → LEK divides by it.
	 */
	rate: number;
	countryId: number | null;
	/** Whether this is the default currency of its own country. */
	isDefault: boolean;
};

/** Response of `GET /api/Currency/list`. */
export type CurrencyList = {
	countryId: number;
	/**
	 * True only where orders may be registered in more than one currency.
	 * Never render a currency selector when this is false — the API discards the choice.
	 */
	dualCurrencyEnabled: boolean;
	defaultCurrencyId: number;
	currencies: CurrencyInfo[];
};
